import { render, staticRenderFns } from "./ChefiaAprovacao.vue?vue&type=template&id=7766fd3c&scoped=true&"
import script from "./ChefiaAprovacao.vue?vue&type=script&lang=js&"
export * from "./ChefiaAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./ChefiaAprovacao.vue?vue&type=style&index=0&id=7766fd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7766fd3c",
  null
  
)

export default component.exports